import { get, post, postimg } from "../http/http"; //引入封装好的get和post方法
// 封装请求的方式
//首页banner
export function getBanners() {
  return get("/indexbanner");
}
//首页新闻
export function getnews() {
  return get("/indexzixun");
}

//新人福利
export function getwelfarelist() {
  return get("/indexcoupons");
}

//推荐
export function getTuijian() {
  return get("/indexTuijian");
}

//初创必备
export function getBooticon() {
  return get("/indexbooticon");
}

//首页广告
export function getappads(adstype) {
  return get("/appads", { adstype: adstype });
}
//会员中心推荐
export function getucenterTuijian() {
  return get("/ucenterTuijian");
}

//公司注册banner
export function getregCombobanner() {
  return get("/regCombobanner");
}

//公司注册热门专区
export function getregCombo() {
  return get("/regCombo");
}

//公司注册其他服务
export function getregServiceCombo() {
  return get("/regServiceCombo");
}
//公司注册静态页面
export function getregPageData() {
  return get("/regPageData");
}

//代理记账banner
export function getjizhangCombobanner() {
  return get("/jizhangCombobanner");
}

//代理记账热门专区
export function getjizhangCombo() {
  return get("/jizhangCombo");
}

//代理记账口碑推荐
export function getjizhangServiceCombo() {
  return get("/jizhangServiceCombo");
}

//代理记账静态
export function getjizhangPageData() {
  return get("/jizhangPageData");
}

//商标注册banner
export function getshangbiaoCombobanner() {
  return get("/shangbiaoCombobanner");
}

//商标注册申请
export function getshangbiaoCombo() {
  return get("/shangbiaoCombo");
}

//商标注册回复
export function getshangbiaoServiceBackCombo() {
  return get("/shangbiaoServiceBackCombo");
}

//商标注册热门
export function getshangbiaoServiceHotCombo() {
  return get("/shangbiaoServiceHotCombo");
}

//商标注册静态
export function getshangbiaoPageData() {
  return get("/shangbiaoPageData");
}

//知识产权banner
export function getzhishiCombobanner() {
  return get("/zhishiCombobanner");
}

//知识产权发明专利申请
export function getzhishiFamingCombo() {
  return get("/zhishiFamingCombo");
}

//知识产权实用专利申请
export function getzhishiShiyongCombo() {
  return get("/zhishiShiyongCombo");
}
//知识产权实用专利申请
export function getzhishiWaiguanCombo() {
  return get("/zhishiWaiguanCombo");
}
//知识产权复审
export function getzhishiBackreviewCombo() {
  return get("/zhishiBackreviewCombo");
}
//知识产权版权服务
export function getzhishiBanquanCombo() {
  return get("/zhishiBanquanCombo");
}
//知识产权静态
export function getzhishiPageData() {
  return get("/zhishiPageData");
}

//许可证办理banner
export function getxukezhengCombobanner() {
  return get("/xukezhengCombobanner");
}

//许可证办理人气精选
export function getxukezhengRenqiCombo() {
  return get("/xukezhengRenqiCombo");
}

//许可证办理食品餐饮
export function getxukezhengFoodCombo() {
  return get("/xukezhengFoodCombo");
}

//许可证办理交通运输
export function getxukezhengTrafficCombo() {
  return get("/xukezhengTrafficCombo");
}

//许可证办理静态
export function getxukezhengPageData() {
  return get("/xukezhengPageData");
}

//公司服务banner
export function getcompanyServicebanner() {
  return get("/companyServicebanner");
}

//公司服务板块
export function getcompayservice(cate) {
  return get("/compayservice", { cate: cate });
}

//资讯类型
export function getzixuncate() {
  return get("/zixuncate");
}

//资讯列表
export function getzixun(data) {
  return get("/zixun", data);
}

//资讯详情
export function getzixundetail(data) {
  return get("/zixundetail", data);
}

//产品详情
export function getproductdetail(data) {
  return get("/combodetail", data);
}

//密码登录
export function getlogin(data) {
  return get("/login", data);
}
//验证码登录
export function getloginsms(data) {
  return get("/loginsms", data);
}

//获取openid
export function getgetopenid(data) {
  return get("/getopenid", data);
}

//重置密码
export function getresetPassword(data) {
  return post("/resetPassword", data);
}

//注册
export function getuser(data) {
  return post("/user", data);
}

//支付订单
export function getpayorder(data) {
  return post("/order", data);
}

//个人中心
export function getuserinfo(data) {
  return get("/ucenter", data);
}

//订单列表
export function getmyOrder(data) {
  return get("/myOrder", data);
}

//订单详情
export function getmyOrderDetail(data) {
  return get("/myOrderDetail", data);
}

//管理订单列表
export function getserviceOrder(data) {
  return get("/serviceOrder", data);
}

//管理订单明细
export function getserviceOrderDetail(data) {
  return get("/serviceOrderDetail", data);
}

//设置个人
export function getuserinfoset(data) {
  return get("/userinfo", data);
}

//更新个人信息
export function getupuserinfo(data) {
  return post("/upuserinfo", data);
}

//公司买卖
export function getcompanySale(data) {
  return post("/companySale", data);
}

//资料寄送列表
export function getitemExpressDetail(data) {
  return get("/itemExpressDetail", data);
}

//新增资料寄送
export function getitemExpress(data) {
  return post("/itemExpress", data);
}

//新增资料寄送
export function getitemExpressGetok(data) {
  return post("/itemExpressGetok", data);
}

//开票申请
export function getmyInvoiceQuery(data) {
  return get("/myInvoiceQuery", data);
}

//开票申请管理
export function getcwInvoiceQuery(data) {
  return get("/cwInvoiceQuery", data);
}

//开票申请管理
export function getserviceCustomers(data) {
  return get("/serviceCustomers", data);
}

//开票申请管理
export function getlogoServiceCustomers(data) {
  return get("/logoServiceCustomers", data);
}

//我的logo设计
export function getmylogolist(data) {
  return get("/mylogolist", data);
}

export function getupdateLogoimg(data) {
  return post("/updateLogoimg", data);
}

export function getcwInvoiceApplyOk(data) {
  return post("/cwInvoiceApplyOk", data);
}

//选择公司
export function getinvoicecompany(data) {
  return get("/invoicecompany", data);
}

//选择地区快递费
export function getinvoiceExpressFee() {
  return get("/invoiceExpressFee");
}

//新增开票申请
export function getinvoiceApply(data) {
  return post("/invoiceApply", data);
}

//留资信息
export function getleads(data) {
  return post("/leads", data);
}

//首页静态数据
export function getindexPageData() {
  return get("/indexPageData");
}

//余额
export function getcashDetail(data) {
  return get("/cashDetail", data);
}

//优惠劵
export function getmydownloadcoupon(data) {
  return get("/mydownloadcoupon", data);
}

//验证码登录
export function getcaptchalogin(data) {
  return get("/captchalogin", data);
}

//重置验证码登录
export function getcaptchaResetPass(data) {
  return get("/captchaResetPass", data);
}

//注册验证码登录
export function getcaptcharegister(data) {
  return get("/captcharegister", data);
}

//服务商
export function getproviderApplyPageData() {
  return get("/providerApplyPageData");
}

//服务商录入
export function getprovideApply(data) {
  return post("/provideApply", data);
}

//圈子类型
export function getallCircleTrends(data) {
  return get("/allCircleTrends", data);
}

//圈子动态
export function gethotCircleTopic(data) {
  return get("/hotCircleTopic", data);
}

//圈子类型列表
export function getallCircleTopic(data) {
  return get("/allCircleTopic", data);
}

//圈子动态点赞
export function getdolike(data) {
  return post("/dolike", data);
}

//圈子动态新增
export function getpublishSubmit(data) {
  return post("/publishSubmit", data);
}

//消息
export function getdialog(data) {
  return get("/dialog", data);
}

//消息通知
export function getznnews(data) {
  return get("/znnews", data);
}

//客服
export function gethistoryMsg(data) {
  return get("/historyMsg", data);
}

//聊天
export function getsendDialogmsg(data) {
  return post("/sendDialogmsg", data);
}

//聊天
export function getlastMsg(data) {
  return get("/lastMsg", data);
}

//客服
export function getallcity() {
  return get("/allcity");
}

//医疗器械
export function getyiliaoqixieCombo() {
  return get("/yiliaoqixieCombo");
}

//投诉建议
export function getsuggest(data) {
  return post("/suggest", data);
}

//客服2
export function getkefuchannel(data) {
  return get("/kefuchannel", data);
}

//记账申报公司
export function getmyjizhangPage(data) {
  return get("/myjizhangPage", data);
}

//记账申报查询
export function getmyJizhangQuery(data) {
  return get("/myJizhangQuery", data);
}

//记账申报公司管理
export function getcwjizhangPage(data) {
  return get("/cwjizhangPage", data);
}

//记账申报查询管理
export function getcwJizhangQuery(data) {
  return get("/cwJizhangQuery", data);
}

//记账申报新增
export function getcwJizhangDeclare(data) {
  return post("/cwJizhangDeclare", data);
}

//服务的公司
export function getserviceCompanys(data) {
  return get("/serviceCompanys", data);
}

//余额支付
export function getorderpayment(data) {
  return post("/orderpayment", data);
}

export function getrechargepayment(data) {
  return post("/rechargepayment", data);
}

export function getorderSecPayment(data) {
  return post("/orderSecPayment", data);
}

//法务
export function getfwzxpayment(data) {
  return post("/fwzxpayment", data);
}

//logo购买
export function getlogopayment(data) {
  return post("/logopayment", data);
}

//领取优惠券

export function getreceivecoupon(data) {
  return post("/receivecoupon", data);
}

//商标注册
export function getshangbiaoForm(data) {
  return post("/shangbiaoForm", data);
}

//友情连接
export function getfriendlinks() {
  return get("/friendlinks");
}

//免费设计logo
export function getlogodesign(data) {
  return post("/logodesign", data);
}

//设计师
export function getdesigner() {
  return get("/designer");
}

//视频法务
export function getindexfwvideos() {
  return get("/indexfwvideos");
}

export function getindexcsvideos() {
  return get("/indexcsvideos");
}

//视频banner
export function getvideosPageData() {
  return get("/videosPageData");
}

export function getindexmsgnum(data) {
  return get("/indexmsgnum", data);
}

//视频列表
export function getcsvideos(data) {
  return get("/csvideos", data);
}

//视频列表
export function getfwvideos(data) {
  return get("/fwvideos", data);
}

//视频列表
export function getcsvideoscate(data) {
  return get("/csvideoscate", data);
}

//视频列表
export function getfwvideoscate(data) {
  return get("/fwvideoscate", data);
}

//法务购买
export function getbuyfwzxpage(data) {
  return get("/buyfwzxpage", data);
}
//logo购买
export function getbuylogopage(data) {
  return get("/buylogopage", data);
}

//法务购买
export function getprivacypage() {
    return get("/privacypage");
  }

//推荐客户
export function getreferCustomers(data) {
  return post("/referCustomers", data);
}

//开始办理
export function getstartProcess(data) {
  return post("/startProcess", data);
}

//结束办理
export function getendProcess(data) {
  return post("/endProcess", data);
}

//办理进度
export function getorderProcess(data) {
  return post("/orderProcess", data);
}



// WEBPACK FOOTER //
// ./src/view/api/api.js